import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";

import "./index.css";

const isDemoApplication =
  window.location.pathname.replace(/\/+$/, "") === "/onboarding-tier1-demo";

const Application = React.lazy(() =>
  isDemoApplication
    ? import("./demo/DemoFormApplication")
    : import("./routes/FormRouter"),
);

const rootElement = document.getElementById("root")!;
const root = ReactDOM.createRoot(rootElement);

rootElement.addEventListener("touchstart", (e) => {
  // is not near edge of view, exit
  if (
    e.touches[0].screenX > 20 &&
    e.touches[0].screenX < window.innerWidth - 20
  )
    return;

  // prevent swipe to navigate gesture
  e.preventDefault();
});

const renderAppDev = () => (
  <React.StrictMode>
    <Suspense fallback={<div className="loader" aria-hidden="true" />}>
      <Application />
    </Suspense>
  </React.StrictMode>
);
const renderAppPro = () => (
  <Suspense fallback={<div className="loader" aria-hidden="true" />}>
    <Application />
  </Suspense>
);

root.render(
  process.env.REACT_APP_ENV === "production" ? renderAppPro() : renderAppDev(),
);

reportWebVitals();
